import React, { useMemo, useState } from "react";
import { Link, useParams } from "react-router-dom";

import Navbar from "../../../components/navbar";
import DetailSidebar from "../../../components/detail-sidebar";
import Footer from "../../../components/footer";
import Switcher from "../../../components/switcher";

import {FiCamera, FiChevronUp, FiMapPin} from '../../../assets/icons/vander'

import Lightbox from 'react-18-image-lightbox';
import 'react-18-image-lightbox/style.css';




import heroDefault from "../../../assets/images/bg/cta.jpg";
import { usePackage } from "../../../hooks/usePackage";
import { postComment } from "../../../services/api";





export default function TourDetailOne(){
    const [activeTab, setActiveTab] = useState(1);
    let [photoIndex, setActiveIndex] = useState(0);
    let [isOpen, setOpen] = useState(false);
    const [commentForm, setCommentForm] = useState({ name: "", email: "", phone: "", message: "" });
    const [commentStatus, setCommentStatus] = useState({ error: "", success: "" });
    const [commentSubmitting, setCommentSubmitting] = useState(false);

    const params = useParams();
    const id = params.id;
    const { data, loading, error } = usePackage(id);

    const images = useMemo(() => data?.images?.map((img) => img.url) || [], [data]);
    const heroImage = data?.hero_image_url || images[0] || heroDefault;

    const details = data?.details || [];
    const faqs = data?.faqs || [];

    const formatPrice = useMemo(
        () => (priceCents, currency = "USD") => {
            if (priceCents == null) return "";
            const amount = currency === "CLP" ? priceCents : priceCents / 100;
            return new Intl.NumberFormat("es-CL", {
                style: "currency",
                currency,
                minimumFractionDigits: currency === "CLP" ? 0 : 2,
            }).format(amount);
        },
        []
    );

    let handleCLick = (index) => {
        if(!images.length) return;
        setActiveIndex(index)
        setOpen(true);
    }

    const handleCommentSubmit = async (e) => {
        e.preventDefault();
        setCommentStatus({ error: "", success: "" });
        if (!commentForm.name || !commentForm.email || !commentForm.message) {
            setCommentStatus({ error: "Nombre, correo y mensaje son obligatorios.", success: "" });
            return;
        }
        setCommentSubmitting(true);
        try {
            await postComment(id, commentForm);
            setCommentStatus({ error: "", success: "Comentario enviado. Gracias por tu mensaje." });
            setCommentForm({ name: "", email: "", phone: "", message: "" });
        } catch (err) {
            setCommentStatus({ error: err.message || "No se pudo enviar el comentario.", success: "" });
        } finally {
            setCommentSubmitting(false);
        }
    };
    const gallerySlots = [
        {index:0, className:"md:col-span-8 col-span-7"},
        {index:1, className:"md:col-span-4 col-span-5"},
        {index:2, className:"md:col-span-4 col-span-5"},
        {index:3, className:"md:col-span-8 col-span-7"},
    ];
    return(
        <>
         <Navbar navclass="defaultscroll is-sticky" navlight={true} manuclass="justify-end nav-light"/>
        <section className="relative table w-full items-center py-36 bg-top bg-no-repeat bg-cover" style={{backgroundImage: `url(${heroImage})`}}>
            <div className="absolute inset-0 bg-gradient-to-b from-slate-900/60 via-slate-900/80 to-slate-900"></div>
            <div className="container relative">
                <div className="grid grid-cols-1 pb-8 text-center mt-10">
                    <h3 className="text-3xl leading-normal tracking-wider font-semibold text-white">{data?.title ? data.title : 'Tour'}</h3>
                </div>
            </div>
            
            <div className="absolute text-center z-10 bottom-5 start-0 end-0 mx-3">
                <ul className="tracking-[0.5px] mb-0 inline-block">
                    <li className="inline-block uppercase text-[13px] font-bold duration-500 ease-in-out text-white/50 hover:text-white"><Link to="/">Tour</Link></li>
                    <li className="inline-block text-base text-white/50 mx-0.5 ltr:rotate-0 rtl:rotate-180"><i className="mdi mdi-chevron-right"></i></li>
                    <li className="inline-block uppercase text-[13px] font-bold duration-500 ease-in-out text-white" aria-current="page">{data?.title || 'Detalle'}</li>
                </ul>
            </div>
        </section>
        <section className="relative md:py-24 py-16">
            {loading && <p className="text-center text-slate-400">Cargando paquete...</p>}
            {error && <p className="text-center text-red-500">{error}</p>}
            {!loading && !error && data && (
            <div className="container relative">
                <div className="grid md:grid-cols-12 grid-cols-1 gap-6">
                    <div className="lg:col-span-8 md:col-span-7">
                        <div className="grid grid-cols-12 gap-4">
                            {gallerySlots.map((slot)=> {
                                const src = images[slot.index];
                                if(!src) return null;
                                return(
                                    <div className={slot.className} key={slot.index}>
                                        <div className="group relative overflow-hidden rounded shadow dark:shadow-gray-800">
                                            <img src={src} className="w-full lg:h-60 md:h-44 h-48 object-cover" alt={`${data?.title || 'Tour'} foto ${slot.index + 1}`}/>
                                            <div className="absolute inset-0 group-hover:bg-slate-900/70 duration-500 ease-in-out"></div>
                                            <div className="absolute top-1/2 -translate-y-1/2 start-0 end-0 text-center opacity-0 group-hover:opacity-100 duration-500">
                                                <Link to="#" onClick={() => handleCLick(slot.index)} aria-label={`Ver foto ${slot.index + 1} de ${data?.title || 'Tour'}`} className="inline-flex justify-center items-center size-9 bg-red-500 text-white rounded-full lightbox"><FiCamera className="size-4 align-middle"></FiCamera></Link>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>

                        <h5 className="text-2xl font-semibold mt-5">{data?.title ? data.title : 'Tour'}</h5>
                        {data?.activities && data.activities.length > 0 && (
                            <div className="flex flex-wrap gap-2 mt-2">
                                {data.activities.map((act)=>(
                                    <span key={act.id} className="px-2 py-1 rounded-full text-xs font-semibold bg-red-100 text-red-600 dark:bg-red-500/10 dark:text-red-200">
                                        {act.name}
                                    </span>
                                ))}
                            </div>
                        )}
                        <p className="flex items-center text-slate-400 font-medium mt-2"><FiMapPin className="size-4 me-1"></FiMapPin> {data?.place || data?.destination?.name || 'Ubicación no disponible'}</p>
                        <p className="text-red-500 font-semibold mt-2">{formatPrice(data?.price_cents, data?.currency)}</p>

                        <ul className="list-none">
                            {details.map((item,index)=>{
                                return(
                                    <li className="inline-flex items-center me-5 mt-5" key={index}>
                                        <FiMapPin className="size-6 stroke-[1.5] text-red-500"></FiMapPin>

                                        <div className="ms-3">
                                            <p className="font-medium">{item.name}</p>
                                            <span className="text-slate-400 font-medium text-sm">{item.title}</span>
                                        </div>
                                    </li>
                                )
                            })}
                        </ul>

                        <div className="mt-6">
                            <h5 className="text-lg font-semibold">Descripción del recorrido:</h5>

                            <div className="text-slate-400 mt-6">
                                <p className="whitespace-pre-line">{data?.summary || "Pronto más detalles."}</p>
                            </div>
                        </div>

                        <div className="mt-6">
                            <h5 className="text-lg font-semibold">Preguntas y respuestas:</h5>
  

                            
                            <div className="mt-6">
                                {faqs.slice(0,4).map((item,index)=>{
                                    const tabId = item.id || index + 1;
                                    return(
                                        <div className="relative shadow dark:shadow-gray-800 rounded-md overflow-hidden mt-4 first:mt-0" key={tabId}>
                                            <h2 className="text-base font-semibold">
                                                <button type="button" aria-expanded={activeTab === tabId} className={`flex justify-between items-center p-5 w-full font-medium text-start ${activeTab === tabId ? 'bg-gray-50 dark:bg-slate-800 text-red-500' : '' }`} onClick={()=>setActiveTab(tabId)}>
                                                    <span>{item.question}</span>
                                                    <FiChevronUp className={`size-4 shrink-0 ${activeTab === tabId ? '' : 'rotate-180'}`}/>
                                                </button>
                                            </h2>
                                            <div className={activeTab === tabId ? "" : "hidden"}>
                                                <div className="p-5">
                                                    <p className="text-slate-400 dark:text-gray-400">{item.answer}</p>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>

                        <div className="mt-6">
                            <h5 className="text-lg font-semibold">Deja un comentario:</h5>

                            <div aria-live="polite">
                                {commentStatus.error && <p className="text-red-500 mt-2">{commentStatus.error}</p>}
                                {commentStatus.success && <p className="text-green-600 mt-2">{commentStatus.success}</p>}
                            </div>

                            <form className="mt-6" onSubmit={handleCommentSubmit}>
                                <div className="grid lg:grid-cols-12 lg:gap-6">
                                    <div className="lg:col-span-6 mb-5">
                                        <div className="text-left">
                                            <label htmlFor="name" className="font-semibold">Tu nombre:</label>
                                            <input
                                                name="name"
                                                id="name"
                                                type="text"
                                                autoComplete="name"
                                                value={commentForm.name}
                                                onChange={(e)=>setCommentForm({...commentForm, name: e.target.value})}
                                                className="mt-3 w-full py-2 px-3 h-10 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded outline-none border border-gray-100 dark:border-gray-800 focus:ring-2 focus:ring-red-500/40"
                                                placeholder="Nombre"
                                                required
                                            />
                                        </div>
                                    </div>
    
                                    <div className="lg:col-span-6 mb-5">
                                        <div className="text-left">
                                            <label htmlFor="email" className="font-semibold">Tu correo electrónico:</label>
                                            <input
                                                name="email"
                                                id="email"
                                                type="email"
                                                autoComplete="email"
                                                value={commentForm.email}
                                                onChange={(e)=>setCommentForm({...commentForm, email: e.target.value})}
                                                className="mt-3 w-full py-2 px-3 h-10 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded outline-none border border-gray-100 dark:border-gray-800 focus:ring-2 focus:ring-red-500/40"
                                                placeholder="Email"
                                                required
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="grid lg:grid-cols-12 lg:gap-6">
                                    <div className="lg:col-span-6 mb-5">
                                        <div className="text-left">
                                            <label htmlFor="phone" className="font-semibold">Teléfono:</label>
                                            <input
                                                name="phone"
                                                id="phone"
                                                type="tel"
                                                inputMode="tel"
                                                autoComplete="tel"
                                                value={commentForm.phone}
                                                onChange={(e)=>setCommentForm({...commentForm, phone: e.target.value})}
                                                className="mt-3 w-full py-2 px-3 h-10 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded outline-none border border-gray-100 dark:border-gray-800 focus:ring-2 focus:ring-red-500/40"
                                                placeholder="Teléfono (opcional)"
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="grid grid-cols-1">
                                    <div className="mb-5">
                                        <div className="text-left">
                                            <label htmlFor="comments" className="font-semibold">Tu comentario:</label>
                                            <textarea
                                                name="comments"
                                                id="comments"
                                                value={commentForm.message}
                                                onChange={(e)=>setCommentForm({...commentForm, message: e.target.value})}
                                                className="mt-3 w-full py-2 px-3 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded outline-none border border-gray-100 dark:border-gray-800 focus:ring-2 focus:ring-red-500/40 h-28"
                                                placeholder="Escribe tu mensaje"
                                                required
                                            ></textarea>
                                        </div>
                                    </div>
                                </div>
                                <button type="submit" id="submit" name="send" disabled={commentSubmitting} className={`py-2 px-5 inline-flex items-center justify-center gap-2 tracking-wide align-middle duration-500 text-base text-center text-white rounded-md w-full ${commentSubmitting ? 'bg-red-300 cursor-not-allowed' : 'bg-red-500 hover:bg-red-600'}`}>
                                    {commentSubmitting && <span className="inline-block size-4 border-2 border-white/40 border-t-white rounded-full animate-spin" aria-hidden="true"></span>}
                                    {commentSubmitting ? 'Enviando...' : 'Enviar mensaje'}
                                </button>
                            </form>
                        </div>
                    </div>

                    <DetailSidebar
                        mapUrl={data?.map_embed || data?.mapEmbed}
                        priceCents={data?.price_cents}
                        priceCurrency={data?.currency}
                        destination={`${data?.place || data?.destination?.name || ''}${data?.title ? ' - ' + data.title : ''}`}
                        packageId={data?.id}
                        depositPercentDefault={data?.deposit_percent_default}
                        title={data?.title}
                    />
                </div>
            </div>
            )}
        </section>
        <Footer/>
        <Switcher/>
        {isOpen && images.length > 0 && (
                <Lightbox
                    mainSrc={images[photoIndex]}
                    nextSrc={images[(photoIndex + 1) % images.length]}
                    prevSrc={images[(photoIndex + images.length - 1) % images.length]}
                    onCloseRequest={() => setOpen( false )}
                    onMovePrevRequest={() =>
                        setActiveIndex((photoIndex + images.length - 1) % images.length,
                        )
                    }
                    onMoveNextRequest={() =>
                        setActiveIndex((photoIndex + 1) % images.length,
                        )
                    }
                />
            )}
        </>
    )
}
